import React from 'react'

import cargando from "../assets/exito-time.gif"
import "./Loanding.css"
export default function Loading() {
    return (
        <div className="containerCarga">
            <img className="carga" src={cargando} alt="loading gif" />
        </div>
    )
}
